<template>
    <div class="modal__time_list_row">
        <modal_time_item
            v-for="item in rowArray"
            :key="'modal_time_item'"
            :selTime="item"
        />
    </div>

</template>

<script>

import modal_time_item from "./ModalTimeItem.vue";

export default {
    name: "modal_time_row",
    props: {
        rowArray: {
            type: Array,
            required: true,
        }
    },
    components: {modal_time_item},
}
</script>
